import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MessageTemplatesService, MessageTemplate } from 'src/app/core/services/message-templates.service';@Component({
  selector: 'app-message-template-modal',
  templateUrl: './message-template-modal.component.html',
  styleUrls: ['./message-template-modal.component.scss']
})
export class MessageTemplateModalComponent implements OnInit {
  title: string = '';
  response_message: string = '';
  shared_with: string = 'me';
  isSaving: boolean = false;
  template?: MessageTemplate;
  isEditMode: boolean = false;

  sharedWithOptions = [
    { value: 'me', label: 'Me' },
    { value: 'everyone', label: 'Everyone' }
  ];

  constructor(
    public bsModalRef: BsModalRef,
    private readonly _messageTemplatesService: MessageTemplatesService) {}

  ngOnInit(): void {
    if (this.isEditMode && this.template) {
      this.title = this.template.title || '';
      this.response_message = this.template.response_message || '';
      this.shared_with = this.template.shared_with || 'me';
    }
  }

  save(): void {
    if (!this.title?.trim()) {
return;
    }
    if (!this.response_message?.trim()) {
return;
    }

    this.isSaving = true;
    const payload = {
      title: this.title.trim(),
      response_message: this.response_message.trim(),
      shared_with: this.shared_with || 'me'
    };

    const request$ = this.isEditMode && this.template?.id
      ? this._messageTemplatesService.updateMessageTemplate(this.template.id, payload)
      : this._messageTemplatesService.createMessageTemplate(payload);

    request$.subscribe({
      next: () => {
this.bsModalRef.hide();
      },
      error: (err) => {
}
    }).add(() => {
      this.isSaving = false;
    });
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
